import { render, staticRenderFns } from "./PromotionPrompt.vue?vue&type=template&id=5e076b35"
import script from "./PromotionPrompt.vue?vue&type=script&lang=js"
export * from "./PromotionPrompt.vue?vue&type=script&lang=js"
import style0 from "./PromotionPrompt.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports